<template>
  <q-select
    :model-value="modelValue"
    :options="communicationMethodOptions"
    :error="error"
    :error-message="errorMessage"
    :disable="disable"
    hide-bottom-space
    emit-value
    map-options
    outlined
    dense
    behavior="menu"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <template #option="scope">
      <q-item-wrapper
        v-bind="scope.itemProps"
        :icon="scope.opt.icon"
        :color="scope.opt.color"
        :label="scope.opt.label"
      />
    </template>
    <template #selected-item="scope">
      <q-item-wrapper
        dense
        class="invisible-item no-padding"
        :icon="scope.opt.icon"
        :color="scope.opt.color"
        :label="scope.opt.label"
      />
    </template>
  </q-select>
</template>

<script>
import communicationMixin from 'components/partials/communications/communicationMixin'

export default {
  mixins: [communicationMixin],
  props: {
    modelValue: {
      type: String
    },
    disable: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String
    }
  },
  emits: ['update:modelValue'],
  computed: {
    communicationMethodOptions () {
      return this.baseGetCommunicationOptions()
    }
  }
}
</script>
